
window.___gcfg = {
    lang: "en-GB",
    parsetags: "onload"
};

new WOW({ offset: 70 }).init();
function loadSliders() {
	$('.testimonials .carousel-inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 3,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.clients-gallery__inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 6,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$('.products-section__inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 6,
		arrows: false,
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

}

var sliderScript = document.getElementById("deferredSlickScript");

sliderScript.addEventListener('load', function () {
	loadSliders();
});

$(document).ready(function () {

	//$('.toplinks__link').attr("data-text", function () {
	//	return $(this).text();
	//});

	//to exclude pages from mobile add to var below. -- removes sub pages

	var mobPages = ['Gedling & Carlton', 'Arnold', 'Burton Joyce & Calverton', 'Bingham', 'Cotgrave', 'Beeston & Bramcote', 'Bestwood Village', 'Newark', 'City Centre Nottingham', 'Clifton & Ruddington', 'Eastwood & Watnall', 'Grantham & Sleaford', 'Hucknall', 'Lenton & New Basford', 'Long Eaton', 'Mansfield', 'Southwell', 'Sutton in Ashfield', 'West Bridgford', 'Wollaton', 'Derbyshire', 'Leicestershire', 'Nottinghamshire', 'Mix and Match Packages', 'Package 1', 'Package 2', 'Mega Package', 'Ultimate Package', 'Celebration Party', 'Jungle Party', 'Multi-colour Party', 'Princess Party', 'Superhero Party',
		
		'Unicorn Party'];

		$(mobPages).each(function () {
			$("#ctl00_TopLinksMobile_CategoryList option:contains(" + this + ")").remove();
		});

    if ($("#HomepageMarker").length !== 0) {
        $(".catlinks__link").addClass("wow fadeIn");
        $(".header__logo img").addClass("wow flipInX").attr("data-wow-delay", "0.5s");
    } else {
        $(".header__logo img").css("visibility","visible");
    }
   

    //// ADD SLIDEDOWN ANIMATION TO DROPDOWN //
    //$('.toplinks').on('show.bs.dropdown', function (e) {
    //    $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    //    window.scrollBy(0, 1);
    //});


    //// ADD SLIDEUP ANIMATION TO DROPDOWN //
    //$('.toplinks').on('hide.bs.dropdown', function (e) {
    //    $(this).find('.dropdown-menu').first().stop(true, true).slideUp();


    //});

    //$(".toplinks__dropdown-link").each(function (index, value) {
    //    $(this).attr("data-wow-delay", index / 10 + "s");
    //    $(this).attr("data-wow-offset", 0);
    //    $(this).addClass("wow fadeIn");
    //});

	if ($('#HomepageMarker').length > 0) {
		// this removes the '/' between testimonial author & date if there are any testimonials
		// its difficult to style otherwise & is rarely wanted.
		var testimonialAuthors = $(".RotatorTestimonialContent a[itemprop='author']");
		if (testimonialAuthors.length > 0) {
			$(".RotatorTestimonialContent a[itemprop='author']").each(function () {
				$(this)[0].nextSibling.nodeValue = '';
			});
		}
	}

    $("img.has-tooltip").tooltip({
        title: function() {
            return $(this).attr("alt");
        },
        placement: "auto"
    });

    $("a.has-tooltip").tooltip({
        placement: "auto"
    });

    $(window).on("resize", function () {
        setTimeout(function () {
			$('.RotatorTestimonialContent').sameHeight();
        }, 300);

        $('.BookButton').width($('.CheckButton').width());
    }).resize();

    function fixHeights() {
        $('.testimonials .item').sameHeight();
		$('.category-panel__title').sameHeight();
		$('.featured-categories__title').sameHeight();
    }


    setTimeout(fixHeights, 300);

    $(window).on("resize", function () {
        setTimeout(function () {
            fixHeights();
        }, 300);
    });

    

});

